import {createContext, Context} from 'react';
import {BaseHistory} from './history/base';


export const HistoryContext: Context<{
  history: BaseHistory;
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
}> = createContext();
